import type { SalesFilterState } from './salesViewFilters';

export const LS_SHOW_MAP = 'sift:sales-view:showMap';

/** A saved choice wins; otherwise the map starts on only where it fits beside the list. */
export function initialShowMap(saved: string | null, compact: boolean): boolean {
  if (saved === '1') return true;
  if (saved === '0') return false;
  return !compact;
}

/** Selections hidden behind the phone's Filters button, so its badge says how many are on. */
export function countSheetFilters(filters: SalesFilterState): number {
  return (
    filters.cse_manager.length +
    filters.cse_territory_owner.length +
    filters.market_center.length +
    filters.tier.length +
    filters.band.length
  );
}
